import { PetInterface } from 'types/pet';
import { ApiPetProfile } from '../../../api/generated-client/PetProfile-Service-A.v1/models';

// get the minimum required fields for pet profile payload from pet interface
export const getApiPetProfileFromInterface = (pet: PetInterface): ApiPetProfile => ({
  id: pet.id,
  name: pet.name,
  type: {
    id: Number.parseInt(pet.petTypeId),
    name: pet.petType.name,
  },
});
